import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { FormHeaderModule } from '@studiobuki/web-core/lib/form-header';
import { InputModule } from '@studiobuki/web-core/lib/input';
import { RouterModule } from '@angular/router';
import { FormHeaderCheckoutModule } from '@studiobuki/web-core/lib/form-header-checkout';
import { InputCheckoutModule } from '@studiobuki/web-core/lib/input-checkout';
import { TooltipModule } from '@studiobuki/web-core/lib/tooltip';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SafePipeModule } from 'safe-pipe';
import { AccordeonModule } from './components/accordeon/accordeon.module';
import { KonbiniItemComponent } from './components/konbini-item/konbini-item.component';
import { FormCheckoutComponent } from './form-checkout.component';

@NgModule({
  declarations: [FormCheckoutComponent, KonbiniItemComponent],
  imports: [
    CommonModule,
    FormHeaderModule,
    InputModule,
    InputCheckoutModule,
    AngularSvgIconModule,
    TooltipModule,
    ButtonModule,
    RouterModule,
    FormHeaderCheckoutModule,
    SafePipeModule,
    AccordeonModule,
  ],
  exports: [FormCheckoutComponent],
})
export class FormCheckoutModule {}
